var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364.415,
    height: 392.11,
    viewBox: "0 0 364.415 392.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#fff;}.c{fill:#ccc;}.d{fill:#e6e6e6;}.e{fill:#00c070;}.f{fill:#3f3d56;}.g{fill:#a0616a;}.h{fill:#2f2e41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M542.161,361.508,384.637,402.072a20.829,20.829,0,0,1-25.337-14.96l-47.639-185a20.829,20.829,0,0,1,14.96-25.337l146.551-37.738,37.51,16.792,46.44,180.342A20.829,20.829,0,0,1,542.161,361.508Z",
    transform: "translate(-310.999 -139.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M331.625,186.282a14.833,14.833,0,0,0-10.653,18.043l47.639,185a14.833,14.833,0,0,0,18.043,10.653l157.524-40.564a14.833,14.833,0,0,0,10.653-18.043l-45.72-177.547-32.965-14.757Z",
    transform: "translate(-314.51 -142.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M605.117,157.074l-24.379,6.278a6.929,6.929,0,0,1-8.439-4.982l-4.637-18.006a.433.433,0,0,1,.6-.5l36.927,16.4a.433.433,0,0,1-.068.815Z",
    transform: "translate(-405.836 -139.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M562.163,413.768l-71.719,18.468a3.465,3.465,0,0,1-1.728-6.711l71.719-18.468a3.465,3.465,0,0,1,1.728,6.711Z",
    transform: "translate(-375.707 -238.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M580.628,426.076l-85.559,22.032a3.465,3.465,0,1,1-1.728-6.71L578.9,419.365a3.465,3.465,0,0,1,1.728,6.711Z",
    transform: "translate(-377.416 -242.584)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 12.246,
    cy: 12.246,
    r: 12.246,
    transform: "translate(73.22 191.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M519.267,309.121l-95.249,24.519a10.73,10.73,0,0,1-13.052-7.708l-19.961-77.543a10.73,10.73,0,0,1,7.708-13.052l95.249-24.519a10.73,10.73,0,0,1,13.052,7.708l19.961,77.543A10.73,10.73,0,0,1,519.267,309.121Z",
    transform: "translate(-340.437 -165.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M519.267,309.121l-95.249,24.519a10.73,10.73,0,0,1-13.052-7.708l-19.961-77.543a10.73,10.73,0,0,1,7.708-13.052l95.249-24.519a10.73,10.73,0,0,1,13.052,7.708l19.961,77.543A10.73,10.73,0,0,1,519.267,309.121Zm-120.24-72.562a9.468,9.468,0,0,0-6.8,11.516l19.961,77.543a9.468,9.468,0,0,0,11.516,6.8l95.25-24.519a9.468,9.468,0,0,0,6.8-11.516L505.793,218.84a9.468,9.468,0,0,0-11.516-6.8Z",
    transform: "translate(-340.437 -165.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M517.4,250.372l-48.071,12.374a1.722,1.722,0,0,1-2.086-1.083,1.659,1.659,0,0,1,1.168-2.105l48.933-12.6c1.977,1,1.457,3.05.055,3.411Z",
    transform: "translate(-368.704 -178.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M520.84,263.746,472.769,276.12a1.722,1.722,0,0,1-2.086-1.083,1.659,1.659,0,0,1,1.168-2.105l48.933-12.6c1.977,1,1.457,3.05.055,3.411Z",
    transform: "translate(-369.976 -183.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M446.938,284.93l-14.671,3.777a1.867,1.867,0,0,1-2.272-1.342l-4.457-17.313a1.867,1.867,0,0,1,1.342-2.272L441.551,264a1.868,1.868,0,0,1,2.272,1.342l4.457,17.313a1.867,1.867,0,0,1-1.342,2.272Z",
    transform: "translate(-353.301 -185.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M512.842,291.186l-73.365,18.885a1.722,1.722,0,0,1-2.086-1.083,1.659,1.659,0,0,1,1.168-2.105l74.228-19.108c1.977,1,1.457,3.05.055,3.411Z",
    transform: "translate(-357.674 -193.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M516.286,304.564l-73.365,18.885a1.722,1.722,0,0,1-2.086-1.083A1.659,1.659,0,0,1,442,320.26l74.228-19.108C518.208,302.154,517.688,304.2,516.286,304.564Z",
    transform: "translate(-358.946 -198.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M519.727,317.933l-73.365,18.885a1.722,1.722,0,0,1-2.086-1.083,1.658,1.658,0,0,1,1.168-2.105l74.228-19.108C521.649,315.524,521.129,317.572,519.727,317.933Z",
    transform: "translate(-360.218 -203.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.171,331.31,449.805,350.2a1.722,1.722,0,0,1-2.086-1.083,1.659,1.659,0,0,1,1.168-2.105L523.116,327.9C525.093,328.9,524.572,330.949,523.171,331.31Z",
    transform: "translate(-361.491 -208.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M526.612,344.68l-73.365,18.885a1.722,1.722,0,0,1-2.086-1.083,1.659,1.659,0,0,1,1.168-2.105l74.228-19.108C528.534,342.271,528.014,344.319,526.612,344.68Z",
    transform: "translate(-362.762 -213.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M445.1,463.656a1.27,1.27,0,0,1-.8-.055l-.016-.007-3.336-1.414a1.279,1.279,0,0,1,1-2.354l2.162.919,2.833-6.664a1.278,1.278,0,0,1,1.677-.676h0l-.017.044.018-.044a1.28,1.28,0,0,1,.676,1.677l-3.333,7.835a1.279,1.279,0,0,1-.861.737Z",
    transform: "translate(-358.726 -255.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M665.944,467.361H503.28a20.829,20.829,0,0,1-20.806-20.806V255.52a20.829,20.829,0,0,1,20.806-20.806H654.612l32.137,25.616V446.555A20.829,20.829,0,0,1,665.944,467.361Z",
    transform: "translate(-374.362 -174.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M506.791,244.215a14.833,14.833,0,0,0-14.816,14.816V450.066a14.833,14.833,0,0,0,14.816,14.816H669.454a14.833,14.833,0,0,0,14.816-14.816V266.726l-28.243-22.512Z",
    transform: "translate(-377.872 -177.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M677.857,328.258H603.8a3.465,3.465,0,0,1,0-6.929h74.058a3.465,3.465,0,0,1,0,6.929Z",
    transform: "translate(-417.914 -206.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M692.149,346.8H603.8a3.465,3.465,0,0,1,0-6.929h88.35a3.465,3.465,0,1,1,0,6.929Z",
    transform: "translate(-417.914 -213.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M677.86,404.443H603.8a3.464,3.464,0,0,0,0,6.929H677.86a3.464,3.464,0,0,0,0-6.929Z",
    transform: "translate(-417.915 -237.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M692.153,422.993H603.8a3.464,3.464,0,1,0,0,6.929h88.349a3.464,3.464,0,1,0,0-6.929Z",
    transform: "translate(-417.915 -243.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M677.857,494.493H603.8a3.465,3.465,0,0,1,0-6.929h74.058a3.465,3.465,0,0,1,0,6.929Z",
    transform: "translate(-417.914 -267.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M692.149,513.04H603.8a3.465,3.465,0,0,1,0-6.929h88.35a3.465,3.465,0,1,1,0,6.929Z",
    transform: "translate(-417.914 -274.679)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 12.246,
    cy: 12.246,
    r: 12.246,
    transform: "translate(142.8 111.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M552.554,338.048a1.27,1.27,0,0,1-.764-.254l-.014-.01-2.878-2.2a1.279,1.279,0,0,1,1.556-2.03l1.864,1.43,4.4-5.747a1.278,1.278,0,0,1,1.792-.237h0l-.027.038.028-.038a1.28,1.28,0,0,1,.236,1.793l-5.181,6.756a1.279,1.279,0,0,1-1.017.5Z",
    transform: "translate(-398.722 -209.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M563.981,412.034a12.246,12.246,0,0,1-12.244,12.25,2.625,2.625,0,0,1-.315-.013,12.245,12.245,0,1,1,12.559-12.238Z",
    transform: "translate(-395.43 -235.389)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12.246,
    cy: 12.246,
    r: 12.246,
    transform: "translate(142.8 216.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M786.666,261.438H761.492a6.929,6.929,0,0,1-6.929-6.929V235.916a.433.433,0,0,1,.7-.339l31.671,25.09a.433.433,0,0,1-.269.773Z",
    transform: "translate(-474.904 -174.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M569.857,412.136a12.246,12.246,0,0,1-12.244,12.25,2.632,2.632,0,0,1-.315-.013,26.512,26.512,0,0,1,2.377-24.311,12.252,12.252,0,0,1,10.182,12.074Z",
    transform: "translate(-401.307 -235.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M600.334,407.91a3.474,3.474,0,0,1,3.468-3.468h18.454a26.209,26.209,0,0,1,2.276,6.929H603.8a3.468,3.468,0,0,1-3.468-3.461Z",
    transform: "translate(-417.913 -237.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M624.963,422.993a26.435,26.435,0,0,1-.921,6.929H603.8a3.464,3.464,0,1,1,0-6.929Z",
    transform: "translate(-417.915 -243.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M681.837,471.62a3.783,3.783,0,0,1-5.2,1.26L632.5,445.958a3.783,3.783,0,0,1,3.94-6.459l44.137,26.922A3.783,3.783,0,0,1,681.837,471.62Z",
    transform: "translate(-429.13 -249.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M608.929,421.094a30.263,30.263,0,1,1-10.077-41.6A30.263,30.263,0,0,1,608.929,421.094Zm-45.213-27.578a22.7,22.7,0,1,0,31.2-7.558,22.7,22.7,0,0,0-31.2,7.558Z",
    transform: "translate(-400.358 -226.256)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 15.485,
    cy: 15.485,
    r: 15.485,
    transform: "translate(290.048 152.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M793.821,508.97a6.937,6.937,0,0,1,5.247-8.922,6.6,6.6,0,0,1,.92-.113l16.311-26.18L801.4,459.59a5.947,5.947,0,1,1,8.272-8.545l20.572,20.285.041.051a5.387,5.387,0,0,1-.375,6.421l-22.855,27.03a6.511,6.511,0,0,1,.17.659,6.937,6.937,0,0,1-6.226,8.27q-.3.026-.588.026A6.958,6.958,0,0,1,793.821,508.97Z",
    transform: "translate(-489.288 -253.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M437.466,591.527h-7.73l-3.677-29.814h11.408Z",
    transform: "translate(-157.437 -207.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M743.669,754.051H718.746v-.315a9.7,9.7,0,0,1,9.7-9.7H743.67Z",
    transform: "translate(-461.669 -362.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M551.323,577.036l-6.641,3.954-18.413-23.735,9.8-5.836Z",
    transform: "translate(-194.466 -203.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M872.325,734.655l-21.415,12.75-.161-.271a9.7,9.7,0,0,1,3.372-13.3h0l13.079-7.787Z",
    transform: "translate(-509.942 -355.951)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M733.2,644.633c-5.178-60.971-8.258-117.612,10.67-140.718l.146-.179,31.855,12.743.052.114c.107.234,10.7,23.538,8.23,39.212l7.857,36.144,25.62,42.9a2.838,2.838,0,0,1-1.293,4.052l-11.134,4.9a2.851,2.851,0,0,1-3.561-1.113l-27.87-45.445-15.742-34.857a.946.946,0,0,0-1.8.289L747.508,644.7a2.832,2.832,0,0,1-2.821,2.537h-8.655a2.856,2.856,0,0,1-2.828-2.6Z",
    transform: "translate(-465.556 -273.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M752.264,480.506l-.152-.073-.024-.167c-1.19-8.329.219-17.583,4.186-27.5a21.838,21.838,0,0,1,25.346-13.078h0a21.811,21.811,0,0,1,13.909,10.7,21.576,21.576,0,0,1,1.5,17.291c-5,14.627-11.491,28.313-11.556,28.45l-.136.286Z",
    transform: "translate(-473.839 -249.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M695.936,463.816a6.937,6.937,0,0,1,10.195,1.79,6.594,6.594,0,0,1,.428.822l30.234,6.111,8.05-18.917a5.947,5.947,0,1,1,10.9,4.756l-11.8,26.373-.033.056a5.387,5.387,0,0,1-6.146,1.9l-33.323-11.942a6.506,6.506,0,0,1-.558.39,6.937,6.937,0,0,1-9.926-2.936q-.128-.268-.23-.541A6.958,6.958,0,0,1,695.936,463.816Z",
    transform: "translate(-452.267 -253.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M840.54,410.014c-1.492-2.643-3.665-5.063-6.538-6.04-3.71-1.262-7.728.082-11.542.979a21.387,21.387,0,0,1-8.972.531,10.075,10.075,0,0,1-7.167-5.009c-1.983-3.974-.312-8.714-.433-13.153a15.973,15.973,0,0,0-20.127-15.012c-3.653-1.054-6.96-1.152-9.219,1.656a10.718,10.718,0,0,0-10.718,10.718h10.249a10.182,10.182,0,0,0,1.547,7.522c1.809,2.658,4.955,4.581,5.561,7.738.587,3.06-1.493,5.964-3.675,8.188s-4.713,4.428-5.394,7.469a9.261,9.261,0,0,0,1.326,6.661,21.691,21.691,0,0,0,4.657,5.129,68.346,68.346,0,0,0,28.4,14.526c7.379,1.777,15.45,2.237,22.3-1.031a22.146,22.146,0,0,0,9.75-30.872Z",
    transform: "translate(-479.065 -224.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M817.422,760.224H697.631a.63.63,0,1,1,0-1.261H817.422a.63.63,0,1,1,0,1.261Z",
    transform: "translate(-453.634 -368.113)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNoData);
export default __webpack_public_path__ + "static/media/help_no_data.74c0b1c9197a862eca5a10c6d067bbe5.svg";
export { ForwardRef as ReactComponent };